import Vue from 'vue'

import 'normalize.css/normalize.css' // A modern alternative to CSS resets

import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import locale from 'element-ui/lib/locale/lang/en' // lang i18n

import '@/styles/index.scss' // global css

import App from './App'
import store from './store'
import router from './router'
import directive from './directive'

import './icons' // icon
import '@/permission' // permission control
import 'default-passive-events' // 阻止默认的被动事件

import { resetForm, handleTree } from '@/utils'
import * as echarts from 'echarts'
// 挂载全局方法
Vue.prototype.resetForm = resetForm
Vue.prototype.handleTree = handleTree
Vue.prototype.$echarts = echarts

/**
 * If you don't want to use mock-server
 * you want to use MockJs for mock api
 * you can execute: mockXHR()
 *
 * Currently MockJs will be used in the production environment,
 * please remove it before going online ! ! !
 */
// if (process.env.NODE_ENV === 'production') {
//   const { mockXHR } = require('../mock')
//   mockXHR()
// }

// set ElementUI lang to EN
// Vue.use(ElementUI, { locale })
// 如果想要中文版 element-ui，按如下方式声明
Vue.use(ElementUI)
Vue.use(directive)
// 解决跨域
Vue.prototype.HOST = '/api'
Vue.config.productionTip = false
Vue.prototype.$bus = new Vue()
// 注册全局自定义指令
Vue.directive('auth', {
  // 获取router实例
  inserted(el, binding, vnode) {
    const { value } = binding
    const router = vnode.context.$router
    const currentRoute = router.currentRoute
    const { meta } = currentRoute
    const { auth } = meta
    // 判断是否有权限 如果没有权限则移除dom
    if (value && value instanceof Array && value.length > 0) {
      const permissionRoles = value
      const hasPermission = auth.some(role => {
        return permissionRoles.includes(role)
      })
      if (!hasPermission) {
        el.parentNode && el.parentNode.removeChild(el)
      }
    } else {
      throw new Error(`请按照指令格式使用`)
    }
  }
})

function copyMethod(value) {
  let text = ''
  switch (typeof value) {
   case 'number':
    text = value.toString()
    break
   case 'object':
    text = JSON.stringify(value)
    break
   default:
    text = value
    break

    
  }
  let input = document.createElement('textarea')
  input.value = text
  document.body.appendChild(input)
  input.select()
  document.execCommand('copy')
  document.body.removeChild(input)
  input = null
  ElementUI.Message({
    message: '复制成功',
    type: 'success'
  })
  
 }
 
 Vue.directive('copy', {
  bind(el, binding) {
    el.style.cursor='pointer'
   el.handler = () => copyMethod(binding.value)
   el.addEventListener('click', el.handler)
  },
  // 更新参数时更新监听函数
  componentUpdated(el, binding) {
   el.removeEventListener('click', el.handler)
   el.handler = () => copyMethod(binding.value)
   el.addEventListener('click', el.handler)
  },
  unbind(el) {
   el.removeEventListener('click', el.handler)
   el.handler = null
  },
 })

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
